<template>
  <v-dialog v-model="visibility" width="500">
    <v-card style="">
      <div id="conteudo-dialog-confirmar-aula">
        <v-card-title class="headline"></v-card-title>
        <v-card-text class="schedule-confirmation-dialog-text">
          <div>Aula completa</div>

          <div class="rating-dialog-teacher-photo-container">
            <img
              class="rating-dialog-teacher-photo"
              width="100%"
              :src="
                professor.image == undefined
                  ? '/img/user-default-image.png'
                  : professor.image
              "
              alt=""
            />
          </div>
          <div class="rating-dialog-teacher-name">  {{professor.name}}</div>
          <div>Como foi a sua aula?</div>
          <div class="text-center">
            <v-rating
              v-model="grade"
              background-color="#440099"
              color="#440099"
              size="42"
              dense
            ></v-rating>
          </div>

          <!-- JA ADICIONEI AQUI O CAMPO.
          ELE PRECISA SÓ APARECER QUANDO
          A NOTA FOR 4 ESTRELAS OU MENOS -->
          <!-- <v-textarea
            v-model="description"
            solo
            no-resize
            flat
            outlined
            name="input-7-4"
            label="O que poderia melhorar?"
            rows="2"
            mandatory
            class="px-5 mx-5 mt-5"
          ></v-textarea> -->
        </v-card-text>

        <v-card-actions style="padding-top: 45px;">
          <v-btn
            color="secondary"
            rounded
            depressed
            x-large
            class="pl-12 pr-12 mb-12"
            @click="rate"
            style="margin: 0 auto; color: #440099;"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from "@/mixins/dialogs/DialogMixin";
import StudentsRepository from "@/repositories/StudentsRepository";
import { mapState } from "vuex";

export default {
  mixins: [DialogMixin],
  props: {},
  computed: {
    ...mapState(["rating"])
  },
  data() {
    return {
      professor: {},
      grade: undefined,
      defaultForm: {
        name: undefined
      }
    };
  },
  watch: {
    rating: {
      immediate: true,
      handler(rating) {
        if (rating && rating.subject_class) {
          this.professor = rating.subject_class.professor_profile;
        }
      }
    }
  },

  mounted() {
  },

  methods: {
    rate() {
      StudentsRepository.rate({
        professor_id: this.rating.subject_class.professor_id,
        grade: this.grade,
        id: this.rating.subject_class.id,
        student_id: this.rating.subject_class.student_id
      });
      this.$emit("positive");
    }
  }
};
</script>

<style scoped>
/* @import url("https://fonts.googleapis.com/css?family=Montserrat:500&display=swap"); */

.v-card.v-sheet.theme--light {
  background: rgba(255, 255, 255, 1);
  background: -moz-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, rgba(255, 255, 255, 1)),
    color-stop(100%, rgba(250, 250, 250, 1))
  );
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: -o-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: -ms-linear-gradient(
    top,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 1) 0%,
    rgba(250, 250, 250, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#fafafa', GradientType=0 );
}
.schedule-confirmation-dialog-text {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: rgba(45, 35, 58, 0.5);
  line-height: 1.4;
}
.schedule-confirmation-dialog-text span {
  font-size: 21px;
  font-weight: 900;
  color: #440099;
  text-transform: uppercase;
}
.rating-dialog-teacher-photo-container {
  display: flex;
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 999px;
  height: 120px;
  width: 120px;
  border: 4px solid #440099;
  margin: 60px auto 18px;
}
.rating-dialog-teacher-photo {
  border-radius: 999px;
  object-fit: cover;
}
.rating-dialog-teacher-name {
  color: #440099;
  font-weight: 900;
  text-align: center;
  text-transform: capitalize;
  font-size: 21px;
}
</style>
